<div>
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div *ngFor="let control of controls" class="form-row">
      <app-control [control]="control" [form]="form"></app-control>
    </div>

    <div class="form-row">
      <button class="botonGrandeFm" color="accent" mat-raised-button [disabled]="!form.valid">Guardar</button>
    </div>
  </form>
</div>
